const TAX_RATES: Record<string, number> = {
  US: 0.25768,
};

export function getMarginalTaxRate(countryCode: string): number {
  return TAX_RATES[countryCode.toUpperCase()] ?? 0.25768;
}

export const US_MARGINAL_TAX_RATE = 0.25768;
